import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate';
import * as es from 'vee-validate/dist/locale/es'
import { Validator } from 'vee-validate';
import VueTimers from 'vue-timers'
// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
// Toast
import Toasted from 'vue-toasted';
//Clipboard
import VueClipboard from 'vue-clipboard2'

require('./assets/sass/main.sass') //SASS Main File with (Bulma, AnimateCSS)
require('./assets/sass/bulma.sass') //Bulma etxra classes
require('./assets/css/tooltip.css') //Tooltips default css
require('./assets/css/styles.css')
require('./assets/css/muonline.css') // Mu Online Font
// require('./assets/css/gradient-background.css')
require('./assets/css/custom-animations.css')
require('vue2-animate/dist/vue2-animate.min.css') //VueANimate CSS

Vue.use(VeeValidate, {
  locale: 'es',
  classes: true,
  classNames: {
    valid: 'is-success',
    invalid: 'is-danger'
}})
Vue.use(VueTimers)

//Tooltips
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

Validator.localize('es', es);

//Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import {
   faImage, faNewspaper, faHandHoldingMedical,
   faCode, faTrophy, faShoppingCart, faUsers,
   faHome, faCopyright, faDownload, faCircleNotch,
   faEdit, faSignInAlt, faLocationArrow, faPlusCircle,
   faEye, faEyeSlash, faUser, faKey, faExternalLinkAlt,
   faEnvelope, faIdCardAlt, faInfoCircle, faUserSlash,
   faGrinSquintTears, faSmileWink, faGrinBeamSweat,
   faChessRook, faFistRaised, faSignOutAlt, faDragon,
   faMedal, faHeartBroken, faHeartbeat, faPowerOff,
   faToriiGate, faSkull, faCrown, faAddressCard,
   faAngleDoubleLeft, faAngleDoubleRight, faCoins,
   faAward, faExchangeAlt, faLevelUpAlt, faLevelDownAlt,
   faHandshake, faRss, faFlagCheckered
  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faImage, faNewspaper, faHandHoldingMedical, 
  faCode, faTrophy, faShoppingCart, faUsers,
  faHome, faCopyright, faDownload, faExternalLinkAlt,
  faEdit, faSignInAlt, faLocationArrow, faPlusCircle,
  faEye, faEyeSlash, faUser, faKey, faCircleNotch,
  faEnvelope, faIdCardAlt, faInfoCircle, faUserSlash,
  faGrinSquintTears, faSmileWink, faGrinBeamSweat,
  faChessRook, faFistRaised, faSignOutAlt, faDragon,
  faMedal, faHeartBroken, faHeartbeat, faPowerOff,
  faToriiGate, faSkull, faCrown, faAddressCard,
  faAngleDoubleLeft, faAngleDoubleRight, faCoins,
  faAward, faExchangeAlt, faLevelUpAlt, faLevelDownAlt,
  faHandshake, faRss, faFlagCheckered
  )

Vue.component('fa', FontAwesomeIcon)
Vue.use(VueAxios, axios) 
Vue.use(Toasted, {
  iconPack : 'fontawesome'
})
Vue.use(VueClipboard)

Vue.config.productionTip = false

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    var setTitle = nearestWithTitle.meta.title
    if ( typeof setTitle === 'function' ) { document.title = setTitle(to) }
    else { document.title = setTitle }
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.auth.status.loggedIn) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }

});

import Default from '@/layouts/Default'
import Launcher from '@/layouts/Launcher'
import Admin from '@/layouts/Admin'
Vue.component('default-layout', Default)
Vue.component('launcher-layout', Launcher)
Vue.component('admin-layout', Admin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
